export const Footer = () => (
  <footer className="border-t border-ivory/10 px-5 py-10 sm:px-8" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
      <p className="font-display text-sm font-bold uppercase tracking-[0.22em] text-ivory">
        Fede <span className="text-gold">&</span> Fitness Italia
      </p>
      <p className="text-xs uppercase tracking-[0.2em] text-ivory/35">
        Fede · Mente · Corpo — © 2026
      </p>
    </div>
  </footer>
);
